import { faArrowDownAZ } from "@fortawesome/free-solid-svg-icons"
import { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import { productActions } from "../../../../../store/products-slice"
import InfoIcon from "../../../../InfoIcon"
import Pagination from "./pagination"
import Resort from "./resort"

export default function Filter({children}){


    const [showFilter, setShowFilter] = useState(false)

    let defaultproductcount = useSelector((state) => state.product.filterProductCount)
    let pagination = useSelector((state) => state.product.pagination)
    let sliceFilters = useSelector(state => state.product.filter)
    let sliceActions = productActions
    let sliceItems = useSelector(state => state.product.products)

     const { doFilter } = useFilter()
        const { variableValue } = useVariable()

        const [paginationItems, setPaginationItems] = useState([])

        let dispatch=useDispatch()

        const [isMount, setIsMount] = useState(false)



        useEffect(() => {
            let items = []
            if (pagination) {
                pagination.map((item, key) => {
    
                    items.push(<Pagination key={key} products={item} index={key} />)
                })
            }
    
            setPaginationItems(items)
        }, [pagination])



            useEffect(() => {
        
                if (!isMount) {
                    setIsMount(true)
                    return
                }
        
        
                doFilter(sliceFilters, sliceItems, sliceActions)
            }, [sliceFilters])



    return <div className="p-3" >
       
        <div className="card shadow  bg-white rounded p-3 mb-3" style={{ cursor: 'pointer' }} onClick={() => {
            setShowFilter(!showFilter)
        }}  >

            <InfoIcon icon={faArrowDownAZ} size='xl' />

        </div>
        {showFilter &&
            <Fragment>
                <label>Pagination</label><select name="filterPostCount" defaultValue={sliceFilters.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)
                    dispatch(productActions.setFilter({
                        key: 'pagination',
                        value
                    }))

                }} >
                    <option value='' >All</option>

                    {
                        defaultproductcount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <Resort type='title' name='Title' />
                
                <Resort type='type' name='Type' />
                
                
            </Fragment>}
        <input type="text" name="filter-email-username" className="mb-2" defaultValue={sliceFilters.search} placeholder="product title  or product type" onInput={(event) => {
            let value = variableValue(event.target.value)

            dispatch(productActions.setFilter({
                key: 'search',
                value
            }))


        }} />

        {children}

        <div className="pagination-container">{paginationItems}</div>
       
    </div>
}